exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".option-cantor[data-v-cc2d07b6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/workspace/src/views/intelligent-outbound-call/pages/IntelligentOutboundCallRecordTable.vue"],"names":[],"mappings":"AACA,gCAAgC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,kBAAkB,CACrJ","file":"IntelligentOutboundCallRecordTable.vue","sourcesContent":["\n.option-cantor[data-v-cc2d07b6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc2d07b6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/intelligent-outbound-call/pages/IntelligentOutboundCallRecordTable.vue
// module id = 4248
// module chunks = 10